import React from 'react';
import Loader from '@/components/common/Loader';
import useOpportunityConfidenceLevels from '@/hooks/swr/useOpportunityConfidenceLevels';
import translate from '@/lib/intl/translate';
import AddConfidenceLevel from './AddConfidenceLevel';
// eslint-disable-next-line import/no-cycle -- TODO: Fix this the next time the file is edited.
import ConfidenceLevel from './ConfidenceLevel';

function ConfidenceLevelsPage() {
  const { data, isLoading } = useOpportunityConfidenceLevels();

  const opportunityConfidenceLevels = data?.opportunityConfidenceLevels || [];

  const sortedConfidenceLevels = React.useMemo(
    () => opportunityConfidenceLevels.sort((a, b) => a.amount - b.amount),
    [opportunityConfidenceLevels],
  );

  return (
    <div className="p-4">
      <h2 className="mb-4 type-h2">{translate('CONFIDENCE_LEVELS')}</h2>
      <p className="type-body1">{translate('CONFIDENCE_LEVELS_DESCRIPTION')}</p>
      {isLoading && <Loader />}
      {!isLoading && (
        <div className="mt-12 grid gap-8">
          {sortedConfidenceLevels.map((opportunityConfidenceLevel) => (
            <ConfidenceLevel
              key={opportunityConfidenceLevel.confidenceLevelId}
              opportunityConfidenceLevel={opportunityConfidenceLevel}
            />
          ))}
          <AddConfidenceLevel />
        </div>
      )}
    </div>
  );
}

export default ConfidenceLevelsPage;
